import { render } from "./EcoTransportIn.vue?vue&type=template&id=0b992eb1&scoped=true"
import script from "./EcoTransportIn.vue?vue&type=script&lang=js"
export * from "./EcoTransportIn.vue?vue&type=script&lang=js"

import "./EcoTransportIn.vue?vue&type=style&index=0&id=0b992eb1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b992eb1"]])

export default __exports__